import {MIN_MSG, NOT_NULL_MSG} from './messages.js'
import assert from '../assert'

export function positiveFactory(msg = MIN_MSG) {
  return minFactory(0, msg)
}

export function notNullFactory(msg = NOT_NULL_MSG) {
  return value => {
    if (!value) {
      return msg
    }

    return true
  }
}

export function minFactory(minValue, msg = MIN_MSG) {
  assert.number(minValue);

  return value => {
    if (!value) { // skip null
      return true
    }

    if (value < minValue) {
      return msg.replace("{min}", minValue)
    }

    return true
  }
}



// WEBPACK FOOTER //
// ./src/validation/rules.js